export default __webpack_public_path__ + "48aff5e740ceab0de59b6e2a113ff97e.png";